class ShopifyBrandPartnershipFormsModal extends window.ShopifyFormsModalBase {
  constructor() {
    super();
    this.form = this.querySelector('[data-brand-partnership-forms-form]');
    this.partnershipTypeOptions = this.querySelectorAll('[data-partnership-type]');
    this.partnershipTypeOtherCheckbox = this.querySelector('[data-partnership-type-other]');
    this.partnershipTypeOtherField = this.querySelector('[data-partnership-type-other-field]');
    this.partnershipTypeOtherInput = this.querySelector('input[name="partnershipTypeOtherText"]');
    this.stringFields = [
      'firstName', 'lastName', 'jobTitle', 'businessEmail', 'phone',
      'legalBusinessName', 'companyWebsite',
      'customerBase', 'mainIndustry',
      'salesRepOrAdditionalInfo',
    ];
  }

  connectedCallback() {
    super.connectedCallback();
    this.boundHandlePartnershipTypeOtherChange = this.togglePartnershipTypeOtherField.bind(this);
    if (this.partnershipTypeOtherCheckbox) {
      this.partnershipTypeOtherCheckbox.addEventListener('change', this.boundHandlePartnershipTypeOtherChange);
    }
    this.togglePartnershipTypeOtherField();
  }

  disconnectedCallback() {
    if (this.partnershipTypeOtherCheckbox && this.boundHandlePartnershipTypeOtherChange) {
      this.partnershipTypeOtherCheckbox.removeEventListener('change', this.boundHandlePartnershipTypeOtherChange);
    }
    super.disconnectedCallback();
  }

  togglePartnershipTypeOtherField() {
    const isChecked = !!(this.partnershipTypeOtherCheckbox && this.partnershipTypeOtherCheckbox.checked);
    if (this.partnershipTypeOtherField) {
      this.partnershipTypeOtherField.classList.toggle('hidden', !isChecked);
      if (this.partnershipTypeOtherInput) {
        this.partnershipTypeOtherInput.disabled = !isChecked;
        if (!isChecked) this.partnershipTypeOtherInput.value = '';
      }
    }
  }

  resetTransientState() {
    super.resetTransientState();
    this.togglePartnershipTypeOtherField();
  }

  buildPayload() {
    const payload = super.buildPayload();

    const types = Array.from(this.partnershipTypeOptions || [])
      .filter((input) => input.checked)
      .map((input) => input.value);
    if (this.partnershipTypeOtherCheckbox && this.partnershipTypeOtherCheckbox.checked) {
      const otherText = this.partnershipTypeOtherInput ? this.partnershipTypeOtherInput.value.trim() : '';
      types.push(otherText ? `Other: ${otherText}` : 'Other');
    }
    if (types.length) payload.partnershipTypes = types.join(', ');

    return payload;
  }
}

if (!customElements.get('shopify-brand-partnership-forms-modal')) {
  customElements.define('shopify-brand-partnership-forms-modal', ShopifyBrandPartnershipFormsModal);
}
